import React, {Component} from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import ReactDataGrid from 'react-data-grid';
import {SkyLightStateless} from 'react-skylight';
import {Toolbar, Data} from 'react-data-grid-addons';
import {UI_HEIGHT} from '../Common/constants';
import {Grid, Row, Col, Panel, Button, ButtonGroup, Table, ButtonToolbar, Breadcrumb} from 'react-bootstrap';
import {Link} from 'react-router';
import {Line, Doughnut} from 'react-chartjs';
import Time from '../Common/time';
import Selection from '../Common/selection';
import Spinner from '../Widgets/spinner';
import PurchaseQuoteModal from '../../containers/Purchase/purchaseQuoteModal';
import NewFavoriteModal from '../../containers/Favorites/favoriteModal';
import { DatePicker, DisabledDatePicker } from '../Common/datePicker';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import InputField from '../Common/inputField';
import { Field, FieldArray } from 'redux-form';

import { Translate, Localize } from 'react-redux-i18n';

class WarehouseDashboard extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.fourLineButton,

            createReturnOpen: false,
            createQuoteOpen: false,
            createFavoriteOpen: false,
            availableBins: 0,
            totalBins: 0,
            totalPO: 0,
            totalSO: 0,
            totalConvert: 0,
            totalAdjust: 0,

            POs: {
                rows: [],
                allRows: [],
                setDate: null,
                selectedRows: null,
                sortColumn: null,
                sortDirection: null,
            },

            SOs: {
                rows: [],
                allRows: [],
                setDate: null,
                sortColumn: null,
                sortDirection: null,
            },

            zones: {
                rows: [],
                allRows: [],
                sortColumn: null,
                sortDirection: null,
            },

            inventories: {
                rows: [],
                selectedRows: null,
                sortColumn: null,
                sortDirection: null,
            },

            favorites: {
                rows: [],
                selectedRows: null,
                sortColumn: null,
                sortDirection: null,
            }
        };

        this.handleResize = this.handleResize.bind(this);

        this.openReturnCreate = this.openReturnCreate.bind(this);
        this.closeReturnCreate = this.closeReturnCreate.bind(this);
        this.openQuoteCreate = this.openQuoteCreate.bind(this);
        this.closeQuoteCreate = this.closeQuoteCreate.bind(this);
        this.openFavoriteCreate = this.openFavoriteCreate.bind(this);
        this.closeFavoriteCreate = this.closeFavoriteCreate.bind(this);
        this.addFavorite = this.addFavorite.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.props.fetchInventories();
        this.props.fetchFavorites();
        // this.props.fetchWarehouseSalesOrders(1);
        this.props.fetchWarehousePurchaseOrders(1);
        this.props.fetchWarehouses();
        this.props.fetchWarehouseBins(1);

        this.props.fetchTodaysIncomingOrders();
        this.props.fetchTodaysOutgoingOrders();
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Once products are ready, reset state.

    componentWillReceiveProps(nextProps) {
        if (nextProps.todaysIncomingOrders && nextProps.todaysIncomingOrders != this.props.todaysIncomingOrders) {
            let purchaseOrders = [...nextProps.todaysIncomingOrders];

            purchaseOrders.map(purchaseOrder => {
              if (purchaseOrder["Deliver_Warehouse_id"]) {
                purchaseOrder["Warehouse"] = purchaseOrder["Deliver_Warehouse_id"].Name;
              }
              if (purchaseOrder["Vendor_id"]) {
                purchaseOrder["Vendor"] = purchaseOrder["Vendor_id"].Name;
              }
              if (purchaseOrder["ReceivedDate"]) {
                purchaseOrder["ReceivedDateFormatted"] = purchaseOrder["ReceivedDate"].slice(0, 10)
              }
            });
            const newPurchaseOrders = { ...this.state.POs, rows: purchaseOrders};
            this.setState({POs: newPurchaseOrders});
        }

        if (nextProps.todaysOutgoingOrders && nextProps.todaysOutgoingOrders != this.props.todaysOutgoingOrders) {
          let salesOrders = [...nextProps.todaysOutgoingOrders];

          salesOrders.map(salesOrder => {
            if (salesOrder["Deliver_Warehouse_id"]) {
              salesOrder["Warehouse"] = salesOrder["Deliver_Warehouse_id"].Name;
            }
            if (salesOrder["Vendor_id"]) {
              salesOrder["Vendor"] = salesOrder["Vendor_id"].Name;
            }
            if (salesOrder["ReceivedDate"]) {
              salesOrder["ReceivedDateFormatted"] = salesOrder["ReceivedDate"].slice(0, 10)
            }
          });

          const newSalesOrders = { ...this.state.SOs, rows: salesOrders};
          this.setState({SOs: newSalesOrders});
        }

        if (nextProps.inventories && nextProps.inventories != this.props.inventories) {
            var inventories = {...this.state.inventories, rows: nextProps.inventories};
            this.setState({inventories});
        }

        if (nextProps.favorites && nextProps.favorites != this.props.favorites) {
            var favorites = {...this.state.favorites, rows: nextProps.favorites};
            this.setState({favorites});
        }

        if (nextProps.warehouseChosen && nextProps.warehouseChosen != this.props.warehouseChosen) {
          if (this.props.purchaseDate == null) {
            this.props.fetchIncomingOrdersByDate(nextProps.warehouseChosen.value);
          } else {
            this.props.fetchIncomingOrdersByDate(nextProps.warehouseChosen.value + '/' + this.formatDate(this.props.purchaseDate));
          }

          if (this.props.salesDate == null) {
            this.props.fetchOutgoingOrdersByDate(nextProps.warehouseChosen.value);
          } else {
            this.props.fetchOutgoingOrdersByDate(nextProps.warehouseChosen.value + '/' + this.formatDate(this.props.salesDate));
          }


            this.props.fetchWarehousePurchaseOrders(nextProps.warehouseChosen.value);
            this.props.fetchWarehouseSalesOrders(nextProps.warehouseChosen.value);
            this.props.fetchWarehouseBins(nextProps.warehouseChosen.value);
        }

        if (nextProps.salesDate && nextProps.salesDate != this.props.salesDate) {
            if (this.props.warehouseChosen == null) {
              this.props.fetchOutgoingOrdersByDate(this.formatDate(nextProps.salesDate));
            } else {
              this.props.fetchOutgoingOrdersByDate(this.props.warehouseChosen.value + '/' + this.formatDate(nextProps.salesDate));
            }
        }

        if (nextProps.purchaseDate && nextProps.purchaseDate != this.props.purchaseDate) {
            if (this.props.warehouseChosen == null) {
              this.props.fetchIncomingOrdersByDate(this.formatDate(nextProps.purchaseDate));
            } else {
              this.props.fetchIncomingOrdersByDate(this.props.warehouseChosen.value + '/' + this.formatDate(nextProps.purchaseDate));
            }
        }

        if (nextProps.warehouseBinsDetail && nextProps.warehouseBinsDetail != this.props.warehouseBinsDetail) {
            let totalAvailable = 0;
            let totalWarehouseBins = 0;
            let PONotArrive = 0;
            let SONotShip = 0;
            let numConvert = 0;
            let numAdjust = 0;
            nextProps.warehouseBinsDetail.Warehouse_Zone.map(zone => {
                zone.AvailableSpace = Math.floor(Math.random() * (50000 - 0 + 1)) + 0;
                zone.TotalSpace = Math.floor(Math.random() * (100000 - 50000 + 1)) + 50000;
                totalAvailable += zone.AvailableBin;
                totalWarehouseBins += zone.TotalBin;
            });
            PONotArrive = nextProps.warehouseBinsDetail.PONotArrive
            SONotShip = nextProps.warehouseBinsDetail.SONotShip
            numConvert = nextProps.warehouseBinsDetail.Converts
            numAdjust = nextProps.warehouseBinsDetail.Adjusts

            let zones = {...this.state.zones, rows: nextProps.warehouseBinsDetail.Warehouse_Zone}
            this.setState({zones, availableBins: totalAvailable, totalBins: totalWarehouseBins, totalPO: PONotArrive, totalSO: SONotShip, totalConvert: numConvert, totalAdjust: numAdjust});
        }
    }

    formatDate(date) {
      var monthShortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      if (date) {
        var month = String(date).slice(4,7);
        var day = String(date).slice(8,10);
        var year = String(date).slice(11, 15);

        let chosenDateFormatted = '';
        if ( parseInt(monthShortNames.indexOf(month) + 1) < 10) {
          chosenDateFormatted = chosenDateFormatted + '0' + (monthShortNames.indexOf(month)+1) + day;
        } else {
          chosenDateFormatted = chosenDateFormatted + (monthShortNames.indexOf(month)+1) + day;
        }
        chosenDateFormatted = chosenDateFormatted + year;
        return chosenDateFormatted;
      }
      return null;
    }


    dateUpdated(updatedDate, whichDate) {
      var monthShortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      var chosenDateFormatted = '';

      if (updatedDate) {
        var month = String(updatedDate).slice(4,7);
        var day = String(updatedDate).slice(8,10);
        var year = String(updatedDate).slice(11, 15);

        chosenDateFormatted = year + '-';
        if ( parseInt(monthShortNames.indexOf(month) + 1) < 10) {
          chosenDateFormatted = chosenDateFormatted + '0' + (monthShortNames.indexOf(month)+1) + '-' + day;
        } else {
          chosenDateFormatted = chosenDateFormatted + (monthShortNames.indexOf(month)+1) + '-' + day;
        }
      }
      if (whichDate == "purchase") {
        let selectedDateOrders = this.state.POs.allRows.filter(function (obj) {
          return String(obj.ETADate).slice(0, 10) == chosenDateFormatted;
        });

        let newDatePurchaseOrders = { ...this.state.POs, rows: selectedDateOrders, setDate: chosenDateFormatted};
        this.setState({POs: newDatePurchaseOrders});
      } else {
        let selectedDateOrders = this.state.SOs.allRows.filter(function (obj) {
          return String(obj.DispatchDate).slice(0, 10) == chosenDateFormatted;
        });
        let newDateSalesOrders = { ...this.state.SOs, rows: selectedDateOrders, setDate: chosenDateFormatted};
        this.setState({SOs: newDateSalesOrders});
      }
    }

    openQuoteCreate() {
        this.setState({createQuoteOpen: true});
    }

    openFavoriteCreate() {
        this.setState({createFavoriteOpen: true});
    }

    closeQuoteCreate() {
        this.setState({createQuoteOpen: false});
    }

    closeFavoriteCreate() {
        this.setState({createFavoriteOpen: false});
    }

    openReturnCreate() {
        this.setState({createReturnOpen: true});
    }

    closeReturnCreate() {
        this.setState({createReturnOpen: false});
    }

    addFavorite(newFavorite) {
        let newRow = {
          Product_id: newFavorite.id,
          ProductNum: newFavorite.ProductNum,
          RefNum: newFavorite.ProductNum,
          PreSale: newFavorite.PreSale,
          InStock: newFavorite.InStock,
          Ordered: newFavorite.Purchased,
          Price: newFavorite.RefPurchasingPrice,
          ProductName: newFavorite.ProductNum.Name
        }
        if (newFavorite.Product) {
          newRow.ProductName = newFavorite.Product["Name"];
        }

        let preRows = this.state.favorites.rows;
        preRows.push(newRow);
        var favorites = {...this.state.favorites, rows: preRows}
        this.setState({favorites});
    }

    handleResize(e) {
        this.setState({tableHeight: window.innerHeight - UI_HEIGHT.fourLineButton});
    }

    // Set product being selected to be currentProduct and navigate user to the edit page

    setCurrentPurchaseOrder(e) {
        e.preventDefault();
        const currentPurchaseOrder = this.state.selectedRows[0];
        this.props.resetCurrentPurchaseOrder();
        this.props.selectPurchaseOrder(currentPurchaseOrder);
        this.context.router.push('/purchaseOrder/' + currentPurchaseOrder.PurchaseOrder_id);
    }

    clickNew(e) {
        e.preventDefault();
        this.props.resetCurrentPurchaseOrder();
        this.context.router.push('/purchaseOrder/new')
    }

    // Render the table head and bind it to the datatable plugin to show a sortable table.

    renderPurchaseOrderTable() {
        if (this.props.todaysIncomingOrdersIsLoading && !this.props.todaysIncomingOrdersError) return <Spinner/>
        else if (this.props.todaysIncomingOrdersError) return <ContentWrapper>
            <div className="alert alert-danger">{JSON.stringify(this.props.todaysIncomingOrdersError)}</div>
        </ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.POs);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var POs = {...this.state.POs, sortColumn, sortDirection};
                this.setState({POs});
            }

            // Handle the row select function

            const onRowSelect = rows => {
                var POs = {...this.state.POs, selectedRows: rows};
                this.setState({POs});
            }

            //Custom Formatter component

            const DateFormatter = React.createClass({
                render() {
                    if (this.props.value) {
                      let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                      let date = new Date(this.props.value)
                      let index = dateMap.indexOf(date.toString().slice(4,3));
                      let localDate = index + date.toString().slice(8, 6);
                      return <span>{date.toString().slice(4, 15)}</span>;;
                    }
                    else return <span className="label label-danger">-</span>;
                }
            });

            const VendorNameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.Name}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            const VendorNumFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            // Column difinition

            const columns = [
              {
                  key: 'PONum',
                  name: <Translate value="po_num" />,
                  resizable: true,
                  sortable: true,
                  width: 90
              },
              {
                  key: 'Vendor',
                  name: <Translate value="vendor" />,
                  resizable: true,
                  sortable: true,
                  width: 155,
              },
              {
                  key: 'TotalPrice',
                  name: <Translate value="total_dollarsign" />,
                  resizable: true,
                  sortable: true,
                  width: 80,
              },
              {
                  key: 'Warehouse',
                  name: <Translate value="shipto" />,
                  resizable: true,
                  sortable: true,
                  width: 120
              },
              {
                  key: 'CreateTime',
                  name: <Translate value="ordered" />,
                  resizable: true,
                  sortable: true,
                  width: 90,
                  formatter: DateFormatter
              },
              {
                  key: 'PurchaseStatus',
                  name: <Translate value="status" />,
                  resizable: true,
                  sortable: true,
                  width: 80
              },
            ]

            return (
              // React Table Purchase Orders Scheduled to Arrive
                <Row>
                  <Col sm={ 12 }>
                    <div id="WarehouseDashboard-dataGrid1">
                        <ReactDataGrid
                            rowKey='PurchaseOrder_id'
                            onGridSort={handleGridSort}
                            columns={columns}
                            rowHeight={25}
                            rowGetter={rowGetter}
                            rowsCount={getSize() }
                            minHeight={this.state.tableHeight}
                            rowHeight={25}
                            onRowSelect={onRowSelect}/>
                    </div>
                </Col>
              </Row>
            )
        }
    }

    renderSalesOrderTable() {
      if (this.props.todaysOutgoingOrdersIsLoading && !this.props.todaysOutgoingOrdersError) return <Spinner/>
      else if (this.props.todaysOutgoingOrdersError) {
        return <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.todaysOutgoingOrdersError)}</div>
      </ContentWrapper>
    }
      else {
          // Parameters of the react-data-grid

          const getRows = () => {
              return Data.Selectors.getRows(this.state.SOs);
          }

          const getSize = () => {
              return getRows().length;
          }

          const rowGetter = rowIdx => {
              var rows = getRows();
              return rows[rowIdx];
          }

          // Handle the sortable function

          const handleGridSort = (sortColumn, sortDirection) => {
              var POs = {...this.state.POs, sortColumn, sortDirection};
              this.setState({POs});
          }

          // Handle the row select function

          const onRowSelect = rows => {
              var POs = {...this.state.POs, selectedRows: rows};
              this.setState({POs});
          }

          //Custom Formatter component

          const DateFormatter = React.createClass({
              render() {
                  if (this.props.value) {
                    let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                    let date = new Date(this.props.value)
                    let index = dateMap.indexOf(date.toString().slice(4,3));
                    let localDate = index + date.toString().slice(8, 6);
                    return <span>{date.toString().slice(4, 15)}</span>;;
                  }
                  else return <span className="label label-danger">-</span>;
              }
          });

          const VendorNameFormatter = React.createClass({
              render() {
                  if (this.props.value) return <span>{this.props.value.Name}</span>;
                  else return <span className="label label-danger">-</span>;
              }
          });

          const VendorNumFormatter = React.createClass({
              render() {
                  if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
                  else return <span className="label label-danger">-</span>;
              }
          });

          // Column difinition

          const columns = [
            {
                key: 'SONum',
                name: <Translate value="so_no" />,
                resizable: true,
                sortable: true,
                width: 90,
                filterable: true
            },
            {
                key: 'Deliver_Customer_num',
                name: <Translate value="cust_id" />,
                resizable: true,
                sortable: true,
                width: 70,
                filterable: true,
            },
            {
                key: 'Deliver_CustomerName',
                name: <Translate value="name" />,
                resizable: true,
                sortable: true,
                width: 120,
                filterable: true,
            },
            {
                key: 'Description',
                name: <Translate value="description" />,
                resizable: true,
                sortable: true,
                width: 120,
                filterable: true,
            },
            {
                key: 'TotalPrice',
                name: <Translate value="total_dollarsign" />,
                resizable: true,
                sortable: true,
                width: 75,
                filterable: true,
            },
            {
                key: 'Sales_User_id',
                name: <Translate value="sales" />,
                resizable: true,
                sortable: true,
                width: 80,
                filterable: true
            },
            {
                key: 'SaleStatus',
                name: <Translate value="status" />,
                resizable: true,
                sortable: true,
                width: 80,
                filterable: true,
            },
              {
                  key: 'OrderDate',
                  name: <Translate value="ordered" />,
                  resizable: true,
                  sortable: true,
                  width: 80,
                  filterable: true,
                  formatter: DateFormatter
              },
              {
                  key: 'DispatchDate',
                  name: <Translate value="scheduled_to_ship" />,
                  resizable: true,
                  sortable: true,
                  width: 120,
                  filterable: true,
                  formatter: DateFormatter
              },
              {
                  key: 'ShipmentDate',
                  name: <Translate value="shipped" />,
                  resizable: true,
                  sortable: true,
                  width: 120,
                  filterable: true,
                  formatter: DateFormatter
              }
          ]

          return (
            // React Table Sales Order Shipped
              <Row>
                <Col sm={ 12 }>
                  <div id="WarehouseDashboard-dataGrid2">
                      <ReactDataGrid
                          rowKey='PurchaseOrder_id'
                          onGridSort={handleGridSort}
                          columns={columns}
                          rowHeight={25}
                          rowGetter={rowGetter}
                          rowsCount={getSize() }
                          minHeight={this.state.tableHeight}
                          rowHeight={25}
                          onRowSelect={onRowSelect}/>
                  </div>
              </Col>
            </Row>
          )
      }
    }

    renderZonesTable() {
      if (this.props.SOIsLoading && !this.props.SOError) return <Spinner/>
      else if (this.props.SOError) return <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.SOError)}</div>
      </ContentWrapper>
      else {
          // Parameters of the react-data-grid

          const getRows = () => {
              return Data.Selectors.getRows(this.state.zones);
          }

          const getSize = () => {
              return getRows().length;
          }

          const rowGetter = rowIdx => {
              var rows = getRows();
              return rows[rowIdx];
          }

          // Handle the sortable function

          const handleGridSort = (sortColumn, sortDirection) => {
              var zones = {...this.state.zones, sortColumn, sortDirection};
              this.setState({zones});
          }

          // Handle the row select function

          const onRowSelect = rows => {
              var zones = {...this.state.zones, selectedRows: rows};
              this.setState({zones});
          }

          //Custom Formatter component

          const DateFormatter = React.createClass({
              render() {
                  if (this.props.value) {
                    let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                    let date = new Date(this.props.value)
                    let index = dateMap.indexOf(date.toString().slice(4,3));
                    let localDate = index + date.toString().slice(8, 6);
                    return <span>{date.toString().slice(4, 15)}</span>;;
                  }
                  else return <span className="label label-danger">-</span>;
              }
          });

          const VendorNameFormatter = React.createClass({
              render() {
                  if (this.props.value) return <span>{this.props.value.Name}</span>;
                  else return <span className="label label-danger">-</span>;
              }
          });

          const VendorNumFormatter = React.createClass({
              render() {
                  if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
                  else return <span className="label label-danger">-</span>;
              }
          });

          // Column difinition

          const columns = [
              {
                  key: 'WarehouseZone_id',
                  name: <Translate value="zone_id" />,
                  resizable: true,
                  sortable: true,
                  width: 100,
                  filterable: true
              },
              {
                  key: 'AvailableBin',
                  name: <Translate value="available_bins" />,
                  resizable: true,
                  sortable: true,
                  width: 100,
                  filterable: true,
              },
              {
                  key: 'TotalBin',
                  name: <Translate value="total_bins" />,
                  resizable: true,
                  sortable: true,
                  width: 100,
                  filterable: true,
              },
              {
                  key: 'AvailableSpace',
                  name: <Translate value="available_space" />,
                  resizable: true,
                  width: 100,
                  filterable: true
              },
              {
                  key: 'TotalSpace',
                  name: <Translate value="total_space" />,
                  resizable: true,
                  width: 100,
                  filterable: true
              }
          ]

          return (
            // React Table Zone Table
              <Row>
                <Col sm={ 12 }>
                  <div id="WarehouseDashboard-dataGrid3">
                      <ReactDataGrid
                          rowKey='WarehouseZone_id'
                          onGridSort={handleGridSort}
                          columns={columns}
                          rowGetter={rowGetter}
                          rowsCount={getSize() }
                          minHeight={this.state.tableHeight}
                          rowHeight={25}
                          onRowSelect={onRowSelect}/>
                  </div>
              </Col>
            </Row>
          )
      }
    }


    renderSalesDatePicker(handleSubmit) {
      return (
        <form onSubmit={handleSubmit}>
          <Field name="SalesDate" component={ DatePicker } />
        </form>
      )
    }

    renderPurchaseDatePicker(handleSubmit) {
      return (
        <form onSubmit={handleSubmit}>
          <Field name="PurchaseDate" component={ DatePicker } />
        </form>
      )
    }

    renderNumPONotArrive() {
      if (this.props.warehouseBinsDetailIsLoading && !this.props.warehouseBinsDetailError) return <Spinner/>
      else if (this.props.warehouseBinsDetailError) {
        return <ContentWrapper>
              <div className="alert alert-danger">{JSON.stringify(this.props.warehouseBinsDetailError)}</div>
          </ContentWrapper>
      }
      else {
        return (
          <div className="dash-number">{this.state.totalPO}</div>
        )
      }
    }

    renderNumSONotShip() {
      if (this.props.warehouseBinsDetailIsLoading && !this.props.warehouseBinsDetailError) return <Spinner/>
      else if (this.props.warehouseBinsDetailError) {
        return <ContentWrapper>
              <div className="alert alert-danger">{JSON.stringify(this.props.warehouseBinsDetailError)}</div>
          </ContentWrapper>
      }
      else {
        return (
          <div className="dash-number">{this.state.totalSO}</div>
        )
      }
    }

    renderTotalConvert() {
      if (this.props.warehouseBinsDetailIsLoading && !this.props.warehouseBinsDetailError) return <Spinner/>
      else if (this.props.warehouseBinsDetailError) {
        return <ContentWrapper>
              <div className="alert alert-danger">{JSON.stringify(this.props.warehouseBinsDetailError)}</div>
          </ContentWrapper>
      }
      else {
        return (
          <div className="dash-number">{this.state.totalConvert}</div>
        )
      }
    }

    renderTotalAdjust() {
      if (this.props.warehouseBinsDetailIsLoading && !this.props.warehouseBinsDetailError) return <Spinner/>
      else if (this.props.warehouseBinsDetailError) {
        return <ContentWrapper>
              <div className="alert alert-danger">{JSON.stringify(this.props.warehouseBinsDetailError)}</div>
          </ContentWrapper>
      }
      else {
        return (
          <div className="dash-number">{this.state.totalAdjust}</div>
        )
      }
    }

    getWarehouseOptions() {
       var warehouseOptions = [];
       this.props.warehouses.map(warehouse => {
          warehouseOptions.push({ value: warehouse.Warehouse_id, label: warehouse.Name });
       })
       return warehouseOptions;
    }

    render() {
        const { handleSubmit, numPurchaseQuotes } = this.props;
        let height = (this.state.tableHeight+ 85).toString();
        let tableCollapseFix = {height: height};
        var warehouseOptions = this.getWarehouseOptions();

        var data = [
            {color: "#97ddf0", label: "test1", value: 2},
            {color: "#fafafa", label: "test2", value: 1}
        ];

        var options = {
            animateRotate: true
        }

        let createDialogStyle = {
            width: '600px',
            marginLeft: '-10%',
        };

        var purchaseOrderPanelHeader = ( <Row>
          <Col xs={8}><h4><Translate value="purchase_order_arrivals" /></h4></Col>
          <Col xs={4}>{this.renderPurchaseDatePicker(handleSubmit)}</Col>
        </Row>);

        var salesOrdersShippedPanelHeader = ( <Row>
          <Col xs={8}><h4><Translate value="sale_orders_to_ship" /></h4></Col>
          <Col xs={4}>{this.renderSalesDatePicker(handleSubmit)}</Col>
        </Row>);

        const warehouseBinsPanelHeader = ( <h4><Translate value="warehouse_bins" /></h4> );

        return (
          //---------------
          // Begin HTML
          //---------------
            <ContentWrapper>
              <Breadcrumb>
                <Breadcrumb.Item active="true">
                  <Translate value="warehouse_dashboard" />
                </Breadcrumb.Item>
              </Breadcrumb>

              <Grid id="warehouse-dashboard" fluid="true">
                <h1><Translate value="warehouse_dashboard" /></h1>
                {/* Dashboard Panels */}
                <Row>
                    <Time />
                    <div className="col-sm-5ths">
                        <Link to="/inventories/receiveHistory">
                            <div className="panel widget">
                                <Row className="row-table">
                                    <Col sm={ 5 } className="bg-blue">
                                      {this.renderNumPONotArrive()}
                                    </Col>
                                    <Col sm={ 7 }>
                                      <h3><Translate value="purchase_orders_not_arrived" /></h3>
                                    </Col>
                                </Row>
                            </div>
                        </Link>
                    </div>

                    <div className="col-sm-5ths">
                      <Link to="/shipping">
                            <div className="panel widget">
                                <Row className="row-table">
                                    <Col sm={ 5 } className="bg-red">
                                      {this.renderNumSONotShip()}
                                    </Col>
                                    <Col sm={ 7 }>
                                      <h3><Translate value="sales_orders_not_shipped" /></h3>
                                    </Col>
                                </Row>
                            </div>
                      </Link>
                    </div>

                    <div className="col-sm-5ths">
                      <Link to="/productConvertReport">
                        <div className="panel widget">
                            <Row className="row-table">
                                <Col sm={ 5 } className="bg-yellow">
                                  {this.renderTotalConvert()}
                                </Col>
                                <Col sm={ 7 }>
                                  <h3><Translate value="products_converted" /></h3>
                                </Col>
                            </Row>
                        </div>
                      </Link>
                    </div>

                    <div className="col-sm-5ths">
                      <Link to="/inventories">
                        <div className="panel widget">
                            <Row className="row-table">
                                <Col sm={ 5 } className="bg-green">
                                  {this.renderTotalAdjust()}
                                </Col>
                                <Col sm={ 7 }>
                                  <h3><Translate value="products_adjusted" /></h3>
                                </Col>
                            </Row>
                        </div>
                      </Link>
                    </div>
                </Row> {/* End Dashboard Panels */}

                {/* Tables */}
                <Row>
                  <Col sm={ 6 }>
                    <h2><Translate value="purchase_overview" /></h2>
                    <Panel header={purchaseOrderPanelHeader} style={ tableCollapseFix }>
                      {this.renderPurchaseOrderTable() }
                    </Panel>
                  </Col>

                  <Col sm={ 6 }>
                    <h2><Translate value="sale_overview" /></h2>
                    <Panel header={salesOrdersShippedPanelHeader} style={ tableCollapseFix }>
                      {this.renderSalesOrderTable() }
                    </Panel>
                  </Col>
                </Row> {/* End Tables */}

                {/* <Field name="Warehouse" component={Selection} options={warehouseOptions} />
                <Row>
                  <Col xs={12} className="text-center">
                    <Panel header={warehouseBinsPanelHeader} >
                      <span>{this.state.availableBins} <Translate value="available_bins" /> / {this.state.totalBins} <Translate value="total_bins" /></span>
                    </Panel>
                    <Panel>
                      {this.renderZonesTable()}
                    </Panel>
                  </Col>
                </Row> */}
              </Grid>

                <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.createQuoteOpen} onCloseClicked={() => {
                    this.closeQuoteCreate()
                } } title="Create a Purchase Quote">
                    <PurchaseQuoteModal closeC={this.closeQuoteCreate}/>
                </SkyLightStateless>
                <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.createFavoriteOpen} onCloseClicked={() => {
                    this.closeFavoriteCreate()
                } } title="Create a new Favorite">
                    <NewFavoriteModal closeC={this.closeFavoriteCreate} closeA={this.addFavorite}/>
                </SkyLightStateless>
            </ContentWrapper>
        );
    }
}


export default WarehouseDashboard;



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/warehouseDashboard.jsx